import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SquareTwoLinesThreeCirclesIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V15C21 16.1046 20.1046 17 19 17H5C3.89543 17 3 16.1046 3 15V6ZM19 6L5 6V15H19V6Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M9 12C9 11.4477 9.44772 11 10 11L14 11C14.5523 11 15 11.4477 15 12 15 12.5523 14.5523 13 14 13H10C9.44772 13 9 12.5523 9 12zM8 9.36377C8 8.81148 8.44772 8.36377 9 8.36377H15C15.5523 8.36377 16 8.81148 16 9.36377 16 9.91605 15.5523 10.3638 15 10.3638H9C8.44772 10.3638 8 9.91605 8 9.36377z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M10 19C10 19.5523 9.55228 20 9 20 8.44772 20 8 19.5523 8 19 8 18.4477 8.44772 18 9 18 9.55228 18 10 18.4477 10 19zM13 19C13 19.5523 12.5523 20 12 20 11.4477 20 11 19.5523 11 19 11 18.4477 11.4477 18 12 18 12.5523 18 13 18.4477 13 19zM16 19C16 19.5523 15.5523 20 15 20 14.4477 20 14 19.5523 14 19 14 18.4477 14.4477 18 15 18 15.5523 18 16 18.4477 16 19z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
